import React from 'react';

const ShoppingBasket = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'>
            <path
                d='M15 11L14 20M19 11L15 4M2 11H22M3.5 11L5.1 18.4C5.1935 18.8586 5.44485 19.2698 5.81028 19.5621C6.17572 19.8545 6.63211 20.0094 7.1 20H16.9C17.3679 20.0094 17.8243 19.8545 18.1897 19.5621C18.5552 19.2698 18.8065 18.8586 18.9 18.4L20.6 11M4.5 15.5H19.5M5 11L9 4M9 11L10 20'
                stroke='currentColor'
                stroke-width='1.8'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};

export default ShoppingBasket;
